import { ModuleWithProviders, NgModule } from '@angular/core';

import { LanguageService } from './language.service';
import { LanguageConfigurationService } from './language-configuration.service';
import { provideTranslations } from './provide-translations';
import { TofeLanguageModuleConfig } from './types';

@NgModule({})
export class TofeLanguageModule {
  static forRoot(config: TofeLanguageModuleConfig): ModuleWithProviders<TofeLanguageModule> {
    LanguageConfigurationService.moduleConfig = config;
    return {
      ngModule: TofeLanguageModule,
      providers: [LanguageConfigurationService, LanguageService, ...provideTranslations()],
    };
  }
}
